"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accountInformation = void 0;

var _requester = require("./utils/requester");

var _schemas = require("./schemas");

var _enums = require("./enums");

const accountInformation = (0, _requester.requestHandler)(async (subResources = ['authenticationClaims'], requester = _requester.authenticatedRequester) => {
  const response = await requester().get(_enums.AUTH_ENDPOINT.accountInformation, {
    params: {
      includes: subResources.length ? subResources.join(',') : null
    }
  });
  const parsedData = await _schemas.accountInformationSchema.validate(response.data);
  return parsedData;
});
exports.accountInformation = accountInformation;